{
  "version": 1,
  "asset_id": "40055597-7609-4119-971d-3f46bd1004ca",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/40055597-7609-4119-971d-3f46bd1004ca/usf-marshall.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/40055597-7609-4119-971d-3f46bd1004ca/usf-marshall.jpg",
  "original_filename": "usf-marshall.jpg",
  "size": 1045772,
  "content_type": "image/jpeg",
  "created_at": "2026-07-28T14:45:35Z"
}
